<template>
  <div class="section-card">
    <b-row class="help-text">
      <b-col v-if="immediateCharge" class="text-danger">
        Your card will be charged straight away.
      </b-col>
      <b-col v-else>
        Your card won't be charged until your order is ready to go out.
      </b-col>
    </b-row>

    <b-row v-if="loadingStoredCards">
      <b-col>
        <loading-spinner data-cy="stripe-loading-spinner">
          <div slot="title">
            Please wait while we load the Users Stored Cards
          </div>
        </loading-spinner>
      </b-col>
    </b-row>

    <b-row v-if="processing">
      <b-col>
        <loading-spinner data-cy="processing-spinner">
          <div slot="title">
            Please wait while we store the credit card details
          </div>
        </loading-spinner>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <no-ssr-loader>
          <stripe-payments-user-stored-card-chooser
            v-model="selectedCard"
            :userid="userid"
            @processing="setProcessing"
            @loading="__loading"
          >
            <template v-slot:stored-card-header>
              <div class="mt-4">
                Select from the Stored cards currently linked to your account or enter a new card details.
              </div>
            </template>
            <template v-slot:stored-card-message>
              &#8203;
            </template>
            <template v-slot:enter-new-card-label>
              Enter another card details
            </template>
          </stripe-payments-user-stored-card-chooser>
        </no-ssr-loader>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: 'card-display-stripe-connect-add-card',
  data: function() {
    return {
      loadingStoredCards: false,
      processing: false
    }
  },
  computed: {
    ...mapState('somnambulistui', ['payer', 'orderOneNow', 'orderId']),
    ...mapGetters('somnambulistui', ['getSelectedQuantityObject']),
    immediateCharge() {
      return !this.orderId && this.getSelectedQuantityObject.allowOrderNow && this.orderOneNow
    },
    userid: function() {
      return this.$store.getters['user/userid']
    },
    selectedCard: {
      get: function() {
        if (this.payer && Object.prototype.hasOwnProperty.call(this.payer, 'provider')) {
          return (this.payer.provider === 'stripe_connect_payments') ? this.payer.token : ''
        }
        else {
          return ''
        }
      },
      set: function(val) {
        this.processing = true
        this.$store.dispatch('stripe/loadStoredCardDetails', val)
          .then(cardDetails => {
            this.stripeCardDetails = cardDetails
            this.processing = false
            this.$emit('selected-card', { ...cardDetails, provider: 'stripe_connect_payments', payerid: val })
          })
      }
    }
  },
  methods: {
    __loading: function(val) {
      this.loadingStoredCards = val
    },
    setProcessing: function(val) {
      this.processing = val
    }
  }
}
</script>

<style lang="scss" scoped>
  .section-title {
    margin: 0 0 2em 0;
    width: 100%;
    text-align: center;
  }
  .help-text {
    text-align: center;
    padding-bottom: 2em;
    border-bottom: 1px solid var(--main-border-color);
  }
</style>
